import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private http: HttpClient) { }

  saveComanies(id: any, payload: any) {
    if (id) {
      return this.http.put(urls.API_URL + urls.COMPANIES + `/${id}/${id}`, payload)
      .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.COMPANIES, payload)
    .pipe(catchError(errorHandl));
   
  }

  getCompanies(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.COMPANIES, { params })
      .pipe(catchError(errorHandl));
  }

  getCompanyById(id: any) {
    return this.http.get(urls.API_URL + urls.COMPANIES + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  attachCompnay(id:any, queryParams?: any){
    const params = new HttpParams({ fromObject: queryParams || {} });
    return this.http.get(urls.API_URL + urls.QUICKBOOK + `/${id}/${urls.AUTH_URL}`, { params })
      .pipe(catchError(errorHandl));
  }

  deAttachCompnay(id: any) {
    return this.http.post(urls.API_URL + urls.QUICKBOOK + `/${id}/${urls.DISCONNECT_URL}`,{})
      .pipe(catchError(errorHandl));
  }

  syncAllData(id: any, type: any) {
      return this.http.get(urls.API_URL + type + `/${id}/${urls.SYNC}`)
        .pipe(catchError(errorHandl));
  }

  syncCompanyById(id: any, type: any){
    return this.http.get(urls.API_URL + type + `/${urls.SYNC}/${id}`)
     .pipe(catchError(errorHandl));
  }
}

